export const FLAG_ID = {
  ENABLE_DELIVERY: Number(import.meta.env.VITE_ENABLE_DELIVERY_FLAG_ID) || 0,
  ENABLE_PICKUP: Number(import.meta.env.VITE_ENABLE_PICKUP_FLAG_ID) || 0,
  ENABLE_SHUTTLE: Number(import.meta.env.VITE_ENABLE_SHUTTLE_FLAG_ID) || 0,
  ENABLE_MAINTENANCE_DRIVER_APP:
    Number(import.meta.env.VITE_ENABLE_MAINTENANCE_DRIVER_APP) || 0,
  SYNC_INVOICE_TIMEOUT_FLAG_ID:
    Number(import.meta.env.VITE_SYNC_INVOICE_TIMEOUT_FLAG_ID) || 0,
  ENABLE_FEAT_HARD_CASH_PAYMENT:
    Number(import.meta.env.VITE_ENABLE_FEAT_HARD_CASH_PAYMENT_FLAG_ID) || 0,
  ENABLE_FEAT_SHRIMP_DOWNSTREAM:
    Number(import.meta.env.VITE_ENABLE_FEAT_SHRIMP_DOWNSTREAM_FLAG_ID) || 0,
  ENABLE_NEW_IRREGULARITY_ENUM:
    Number(import.meta.env.VITE_ENABLE_NEW_IRREGULARITY_ENUM_FLAG_ID) || 0,
  ENABLE_FEAT_GEOLOCATION_FLAG_ID:
    Number(import.meta.env.VITE_ENABLE_FEAT_GEOLOCATION_FLAG_ID) || 0,
};
